module.exports = __webpack_public_path__ + "img/5685b08.jpg";